import { render } from "./Division.vue?vue&type=template&id=60e20502&scoped=true"
import script from "./Division.vue?vue&type=script&lang=js"
export * from "./Division.vue?vue&type=script&lang=js"

import "./Division.vue?vue&type=style&index=0&id=60e20502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e20502"]])

export default __exports__